import { render, staticRenderFns } from "./organize.vue?vue&type=template&id=506c4d3f&"
import script from "./organize.vue?vue&type=script&lang=js&"
export * from "./organize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506c4d3f')) {
      api.createRecord('506c4d3f', component.options)
    } else {
      api.reload('506c4d3f', component.options)
    }
    module.hot.accept("./organize.vue?vue&type=template&id=506c4d3f&", function () {
      api.rerender('506c4d3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/organize.vue"
export default component.exports